var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoStep({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_31)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_31)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F9F5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FA532E"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.733 19.232C17.9757 19.232 18.1793 19.3187 18.344 19.492C18.5173 19.6653 18.604 19.8733 18.604 20.116C18.604 20.3587 18.5173 20.5667 18.344 20.74C18.1793 20.9133 17.9757 21 17.733 21H13.469C13.1743 21 12.9187 20.896 12.702 20.688C12.494 20.48 12.39 20.2287 12.39 19.934C12.39 19.726 12.442 19.5397 12.546 19.375C12.6587 19.2017 12.806 19.0673 12.988 18.972C14.0713 18.2267 14.873 17.5463 15.393 16.931C15.9217 16.307 16.2467 15.787 16.368 15.371C16.4893 14.9463 16.55 14.5087 16.55 14.058C16.55 13.7113 16.4503 13.434 16.251 13.226C16.0517 13.018 15.7917 12.914 15.471 12.914C15.2023 12.914 14.977 12.9833 14.795 13.122C14.6217 13.252 14.509 13.4383 14.457 13.681C14.379 13.8197 14.2663 13.9323 14.119 14.019C13.9803 14.1057 13.8287 14.149 13.664 14.149C13.3953 14.149 13.17 14.058 12.988 13.876C12.8147 13.694 12.728 13.4817 12.728 13.239C12.728 13.1263 12.7583 12.9963 12.819 12.849C13.0097 12.303 13.3347 11.8783 13.794 11.575C14.2533 11.263 14.8037 11.107 15.445 11.107C16.017 11.107 16.524 11.2283 16.966 11.471C17.408 11.7137 17.7503 12.056 17.993 12.498C18.2443 12.94 18.37 13.4427 18.37 14.006C18.37 14.7167 18.1533 15.488 17.72 16.32C17.2867 17.1433 16.4893 18.114 15.328 19.232H17.733Z",
    fill: "#FDF7F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_31",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2_31"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.32549 0 0 0 0 0.180392 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_31"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_31",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoStep);
export default __webpack_public_path__ + "static/media/two-step.f451e8f4df01203ae9caaa4d18680903.svg";
export { ForwardRef as ReactComponent };